import {PipeContext} from '../execution/pipes';
import {PlatedMaterialValue} from '../types/data';
import {WATER as MATERIAL_WATER} from '../types/materials';

export function makeWaterPlatedMaterial(
  context: PipeContext,
): PlatedMaterialValue {
  const plate = context.lab.presetPlates.eppendorfs;
  const well = context.lab.plate(plate).getSharedWell(MATERIAL_WATER.id);
  return {
    kind: 'plated_material',
    material: MATERIAL_WATER,
    plate: plate,
    well: well.id,
  };
}
